
import { types,constants } from './actions';

export const initialPosition = {
x:0,
y:0,
z: constants.MIN_ZOOM,
oldX:0,
oldY : 0,
rotationDegree : 0,
invert:0,
height : 0,
width : 0,
newHeight : 0,
newWidth : 0,
transformOrigin: 'top center'

}



const reducer = (state : any ,action : any) => {
    
switch (action.type)
{
    case types.START_PAN : {

        return {...state,
            oldX : action.pageX,
            oldY : action.pageY}
        }
  
        case types.PAN : {

          const deltaMouseX = action.pageX - state.oldX;
          const deltaMouseY = action.pageY - state.oldY;

          if(action.wrapperRef && action.wrapperRef.current)
          {
              var container =  action.wrapperRef.current;
              container.scrollLeft =  container.scrollLeft + (state.oldX - action.pageX);
              container.scrollTop =  container.scrollTop + (state.oldY - action.pageY);

              
          }

          return {...state,
            x: state.x + deltaMouseX,
            y: state.y + deltaMouseY,
            oldX : action.pageX,
            oldY : action.pageY }  
          }
        case types.BOUND_PAN : {
          const [tx,ty] = move(action,state)
          return {...state,
            x: tx,
            y: ty,
            oldX : action.pageX,
            oldY : action.pageY
          }
        }

          
        case types.ZOOM : {
  
            const [px,py,pz] = zoom(state, action);

            action.wrapperRef.current.scrollTop = action.wrapperRef.current.scrollHeight/2 - action.wrapperRef.current.offsetHeight/2;
           action.wrapperRef.current.scrollLeft = action.wrapperRef.current.scrollWidth/2 - action.wrapperRef.current.offsetWidth/2;

            return {...state, x: px, y:py,z:pz}
        }
          case types.INVERT_COLOR : {
            var val = action.invertClr === 0 ? 100 : 0;
          return state = {...state, invert : val}
          }
          case types.ROTATE : {
            var rot = (action.direction * constants.ROTATION_DEG) +  action.degrees;
            return state = {...state, x : action.x, y : action.y, z : state.z, rotationDegree : rot,transformOrigin:action.transformOrigin}
           
          
          }

          case types.SCALE : {
            var pX = 0;
            var pY = 0;
            var _z = 1;
            if(action.up)
            { 
              _z = (action.factor + constants.ZOOM_STEP < constants.MAX_ZOOM ? action.factor + constants.ZOOM_STEP : constants.MAX_ZOOM );
            }
            else
            {
              _z = (action.factor - constants.ZOOM_STEP > constants.LEAST_POSSIBLE_ZOOM ? action.factor - constants.ZOOM_STEP :constants.LEAST_POSSIBLE_ZOOM );
            }
            
            if(_z !==action.factor)
            {
              
                pX = (action.x * (_z-1))/(action.factor > 1 ? (action.factor -1) : action.factor);
                pY = (action.y * (_z-1))/(action.factor> 1 ? (action.factor -1) : action.factor);
              
            }
         
          
            return state = {...state, x:action.x,y:action.y, pX : 0, pY : 0, z : _z, transformOrigin:action.transformOrigin}
          }
          case types.LOAD : {
            return state = {...state, x:0,y:0,width : action.width, height : action.height,transformOrigin:action.transformOrigin}
          }

          case types.RESET_TO_ORIGINAL : {
            var rot = (action.direction * constants.ROTATION_DEG) +  action.degrees;
           if(Math.abs(rot) === 360)
           {
            rot = 0;
           }


            return state = {...state, x : 0, y : 0, z : constants.MIN_ZOOM, rotationDegree : rot,invert:0}
           
          
          }
            default:
              {
                return state;
              }

            }

}

const move = (action : any, state:any) =>
{
  var [tx,ty] = [state.x,state.y];
  if(action.containerRef && action.imageRef)
  {
     
        var deltaMouseX = action.pageX - state.oldX;
        var deltaMouseY = action.pageY - state.oldY;
        var [_x,_y,_z,_oldX,_oldY]=[state.x,state.y,state.z,state.oldX,state.oldY];
       
        const containerRect = action.containerRef.current?.getBoundingClientRect();
        const imgRect = action.imageRef.current?.getBoundingClientRect();

       

        if(containerRect && imgRect)
        {
          var limitedDeltaX = deltaMouseX;
          var limitedDeltaY = deltaMouseY;
         

          const[wider ,lBound ,rBound ] = [
            (imgRect?.width > (containerRect?.right - containerRect?.left)),
            (deltaMouseX > 0 && (imgRect?.left - containerRect?.left) < 0),
            (deltaMouseX < 0) && (imgRect?.right - containerRect?.right) > 0];

            if(wider || lBound || rBound)
            {
               limitedDeltaX = getLimitedDelta(deltaMouseX, containerRect.left,containerRect.right, imgRect.left, imgRect.right);
               tx =state.x + limitedDeltaX;
               
            }

            const[higher,tBound,bBound] = [
              (imgRect?.height > (containerRect.bottom - containerRect.top)),
              (deltaMouseY > 0 && (imgRect.top-containerRect.top) < 0),
              (deltaMouseY < 0 && (imgRect.bottom - containerRect.bottom) > 0)];

              if(higher || tBound || bBound)
              {
                limitedDeltaY = getLimitedDelta(deltaMouseY,containerRect.top, containerRect.bottom, imgRect.top, imgRect.bottom)
                ty = state.y + limitedDeltaY;
              }
              
            }
          }
         
            return [tx,ty];
}

const getLimitedDelta = (delta : any , containerMin : any, containerMax : any , elementMin : any , elementMax : any ) =>
  {
    // moving up/left
      if(delta > 0)
      {
          if(elementMin > containerMin)
          {
              // dont move
              return 0;
          }
          else if(elementMin + delta > containerMin)
          {
              // out of bounds correction needed
              return containerMin - elementMin;
          }
      }
      // moving down/right
      else if(delta < 0 )
      {
          if(elementMax <  containerMax )
          {
            return 0;
          }
          else if(elementMax + delta < containerMax )
          {
            return containerMax - elementMax;
          }
      }
        return delta;
  }


const zoom = (state: any ,action : any ) =>
{
    var [posX, posY, zoom] = [state.x,state.y,state.z];

   /* if(zoom === constants.MIN_ZOOM)
    {
        return [posX, posY, zoom];
    }*/

   
    if (action.deltaY !== 0 && action.wrapperRef && action.wrapperRef.current) { 

      //action.imageRef.current.style.transformOrigin = "";

        const velocity = action.deltaY * - constants.SCROLL_SPEED/100;
        zoom = Math.max(Math.min(zoom + velocity, constants.MAX_ZOOM),constants.MIN_ZOOM);

        if(zoom !== action.MIN_ZOOM)
        {
            [posX,posY] = getNewPosition(state, action.pageX, action.pageY,zoom,action.wrapperRef);

          
        }
        else
        {
           [posX,posY] = [0,0];
        }

    }
    return [posX, posY, zoom];
}

const getNewPosition = (state: any ,x:number , y : number , zoom : number,wrapperRef:any ) => {
    const [prevZoom, prevPosX, prevPosY] = [state.z, state.x, state.y]

    if (zoom === 1) {
        [x, y] = [0,0];
      return  [x, y];
    }

    if (zoom > prevZoom) {
      // Get container coordinates
      const rect = wrapperRef?.current?.getBoundingClientRect();

      if(!rect)
      {
        [x, y] = [0,0];
        return  [x, y];
      }
      // Retrieve rectangle dimensions and mouse position
      const [centerX, centerY] = [rect.width / 2, rect?.height / 2]
      const [relativeX, relativeY] = [x - rect?.left - window.pageXOffset, y - rect?.top - window.pageYOffset]

      // If we are zooming down, we must try to center to mouse position
      const [absX, absY] = [(centerX - relativeX) / prevZoom, (centerY - relativeY) / prevZoom]
      const ratio = zoom - prevZoom
      return [prevPosX + (absX * ratio), prevPosY + (absY * ratio) ];
      } 
      else {
      // If we are zooming down, we shall re-center the element
      return [(prevPosX * (zoom - 1)) / (prevZoom - 1),(prevPosY * (zoom - 1)) / (prevZoom - 1)];
      }
    }



    export default reducer;
  
